import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import {
  //BrowserRouter as Router,
  //Route,
  //Link,
  Redirect,
  //withRouter
} from 'react-router-dom'

class Signout extends Component {

  componentWillMount() {
    this.props.signoutUser()
  }

  render() {
    return <div><Redirect to={'/signin'}/></div>
  }
}

export default connect(null, actions)(Signout)


// WEBPACK FOOTER //
// ./src/components/auth/signout.js